import Home from '@pages/Home'
import Login from '@pages/Login'
import PageNotFound404 from '@pages/PageNotFound404'
import Quiz from '@pages/Quiz'
import AdminDashBoard from '@pages/backend/AdminDashBoard'
import AdminForgetPassword from '@pages/backend/AdminForgetPassword'
import AdminHome from '@pages/backend/AdminHome'
import AllUser from '@pages/backend/AllUser'
import AllData from '@pages/backend/data/AllData'

import {
    IconChartInfographic,
    IconHome,
    IconNews,
    IconUsers,
} from '@tabler/icons-react'
import ContactData from '@pages/backend/data/ContactData'
export interface menu {
    path?: string
    label?: string
    protected?: boolean
    role?: number[]
    group?: string
    element?: React.ReactNode
    icon?: React.FC<any>
}
export const BackendMenu: menu[] = [
    {
        path: '/login',
        protected: false,
        element: <Login />,
    },
    {
        path: '/backend/home',
        protected: true,
        label: 'Home',
        icon: IconHome,
        element: <AdminHome />,
    },
    {
        label: 'Quiz Data',
        path: '/backend/quiz-data',
        protected: true,
        role: [1, 2],
        icon: IconNews,
        element: <AllData />,
    },
    {
        label: 'Contact Data',
        path: '/backend/contact-data',
        protected: true,
        role: [1, 2],
        icon: IconNews,
        element: <ContactData />,
    },
    {
        label: 'Report',
        path: '/backend/report',
        role: [1, 2, 3],
        protected: true,
        icon: IconChartInfographic,
        element: <AdminDashBoard />,
    },
    {
        path: '/backend/forgetpassword',
        element: <AdminForgetPassword />,
    },
    {
        label: 'Staff / Admin',
        path: '/backend/staff',
        role: [1],
        protected: true,
        icon: IconUsers,
        element: <AllUser />,
    },
]

export const ClientMenu: menu[] = [
    {
        path: '/',
        protected: false,
        element: <Home />,
    },
    {
        path: '/calc/:person_type',
        protected: false,
        element: <Quiz />,
    },
    {
        path: '*',
        protected: false,
        element: <PageNotFound404 />,
    },
]
